import React from 'react';
import { Page } from 'src/Common/Components/Page';
import { LinkProfileManagementContent } from './Components/LinkProfileManagementContent';
import { TemplateGroupsProvider } from 'src/LabelManagement/Providers/TemplateGroupsProvider';
import { CompartmentGeneratorProvider } from 'src/CompartmentManagement/Providers/CompartmentGeneratorProvider';

export const LinkProfileManagement = (): React.JSX.Element => (
  <Page title="Link Profiles" accessKey={'linkProfiles'} isSearchable={true}>
    <TemplateGroupsProvider>
      <CompartmentGeneratorProvider>
        <LinkProfileManagementContent />
      </CompartmentGeneratorProvider>
    </TemplateGroupsProvider>
  </Page>
);
